<ng-container *ngIf="overlayShown$ | async; let overlay">
    <loading-overlay class="main-overlay" *ngIf="overlay.show" [message]="overlay.message"></loading-overlay>
</ng-container>

<router-outlet></router-outlet>
